module.exports = __webpack_public_path__ + "static/media/logo-paysafecard.29857050.svg";